<div>
  <ng-select
    [items]="items"
    bindLabel="label"
    groupBy="type"
    placeholder="Search Store"

    [typeahead]="input$"
    [loading]="loading"
    [virtualScroll]="true"

    (change)="onChange($event)"
    (keydown.enter)="onEnter($event)"
    [(ngModel)]="item"
  >
    <ng-template ng-label-tmp let-item="item">
      {{ item.title }}
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      {{ item.title }}
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item">
      {{ item.type | titlecase }}
    </ng-template>

    </ng-select>
  </div>